import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Progress } from "../components/ui/progress";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Lock } from "lucide-react";

export default function Audits() {
  const navigate = useNavigate();
  const [audits, setAudits] = useState([]);
  const [campagnes, setCampagnes] = useState([]);
  const [campagneId, setCampagneId] = useState("");
  const [statut, setStatut] = useState("");

  const archivedCampagnes = new Set(campagnes.filter((c) => c.statut === "ARCHIVE").map((c) => c.campagne_id));

  useEffect(() => {
    api.get("/campagnes").then((res) => {
      setCampagnes(res.data);
      const cross = res.data.find((c) => c.type_campagne === "CROSS_ASSESSMENT");
      if (cross) setCampagneId(cross.campagne_id);
    });
  }, []);

  useEffect(() => {
    const params = {};
    if (campagneId) params.campagne_id = campagneId;
    if (statut) params.statut = statut;
    api.get("/audits", { params }).then((res) => setAudits(res.data));
  }, [campagneId, statut]);

  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto space-y-4" data-testid="audits-page">
      <h1 className="font-heading text-3xl font-black uppercase tracking-tight">Audits Terrain</h1>
      <div className="flex gap-3 flex-wrap">
        <Select value={campagneId} onValueChange={setCampagneId}>
          <SelectTrigger className="w-56" data-testid="audits-campagne-select"><SelectValue placeholder="Campagne" /></SelectTrigger>
          <SelectContent>{campagnes.map((c) => <SelectItem key={c.campagne_id} value={c.campagne_id}>{c.nom}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={statut || "ALL"} onValueChange={(v) => setStatut(v === "ALL" ? "" : v)}>
          <SelectTrigger className="w-48" data-testid="audits-statut-select"><SelectValue placeholder="Statut" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">Tous statuts</SelectItem>
            {["NON_DEMARRE", "EN_COURS", "A_REVOIR", "TERMINE", "VALIDE", "ARCHIVE"].map((s) => <SelectItem key={s} value={s}>{s.replace(/_/g, " ")}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3">
        {audits.map((a) => (
          <Card key={a.audit_id} className="cursor-pointer hover:shadow-md" data-testid="audit-list-item" onClick={() => navigate(`/audits/${a.audit_id}`)}>
            <CardContent className="p-4 flex items-center justify-between gap-4 flex-wrap">
              <div>
                <div className="font-semibold">{a.site_nom}</div>
                <div className="text-xs text-muted-foreground">{a.site_categorie} · {a.auditeur_principal || "Non assigné"}</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-32">
                  <Progress value={Number(a.progression || 0)} />
                </div>
                <Badge variant="outline">{(a.statut || "").replace(/_/g, " ")}</Badge>
                {archivedCampagnes.has(a.campagne_id) && (
                  <Badge data-testid="audit-readonly-list-badge" className="bg-slate-600 text-white gap-1"><Lock className="h-3 w-3" /> Lecture seule</Badge>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
        {audits.length === 0 && <p className="text-sm text-muted-foreground">Aucun audit trouvé pour ces filtres.</p>}
      </div>
    </div>
  );
}
